// AWS Cognito configuration
//
// All values MUST come from environment variables injected at build time
// (see .env.development for local dev, and the GitHub Actions workflows
// which inject VITE_* vars from repository/environment variables for
// dev/prod builds). There are no hardcoded fallback credentials here -
// a previous version of this file hardcoded the dev Cognito pool/client
// IDs as defaults, which meant a misconfigured prod build would silently
// fall back to the dev user pool instead of failing loudly.

function requireEnv(name) {
  const value = import.meta.env[name];
  if (!value) {
    throw new Error(
      `Missing required environment variable: ${name}. ` +
      `Set it in .env.development (local) or as a build-time variable in CI/CD.`
    );
  }
  return value;
}

const userPoolId = requireEnv('VITE_COGNITO_USER_POOL_ID');
const userPoolClientId = requireEnv('VITE_COGNITO_CLIENT_ID');
const region = import.meta.env.VITE_AWS_REGION || 'eu-west-2';
const domain = requireEnv('VITE_COGNITO_DOMAIN');

export const cognitoConfig = {
  userPoolId,
  userPoolClientId,
  region,
  domain,

  // OAuth configuration
  oauth: {
    domain: `${domain}.auth.${region}.amazoncognito.com`,
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: requireEnv('VITE_REDIRECT_SIGN_IN'),
    redirectSignOut: requireEnv('VITE_REDIRECT_SIGN_OUT'),
    responseType: 'code'
  }
}

// Amplify configuration for v6
export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
      identityPoolId: undefined, // Not using identity pool
      loginWith: {
        email: true,
        username: false
      }
    }
  }
}
